import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-wrapper" }
const _hoisted_3 = { class: "header__left" }
const _hoisted_4 = {
  key: 0,
  class: "header__right"
}

import { computed } from 'vue'
import HeaderMenu from '@/components/menu/HeaderMenu.vue'
import HeaderLogo from '@/components/images/HeaderLogo.vue'
import ReportDownload from '@/components/ReportDownload.vue'
import IconLogout from '@/components/images/IconLogout.vue'
import RegionSelect from './RegionSelect.vue'
import store from '@/store'


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderBlock',
  setup(__props) {

const user = computed(() => store.state.user)

const handleLogout = () => {
  store.logout()
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "header__logo"
        }, {
          default: _withCtx(() => [
            _createVNode(HeaderLogo)
          ]),
          _: 1
        }),
        _createVNode(RegionSelect)
      ]),
      _createVNode(HeaderMenu),
      (user.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(ReportDownload),
            _createElementVNode("a", {
              class: "header__login",
              href: "#",
              onClick: _withModifiers(handleLogout, ["prevent"])
            }, [
              _createTextVNode(_toDisplayString(user.value.title) + " ", 1),
              _createVNode(IconLogout)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})